import { Mail, Trash2 } from "lucide-react";

export default function CartsTab(props) {
  const { carts, deleteCart, nudge } = props;
  return (
          <div className="border border-zinc-800" data-testid="carts-table">
            {carts.length === 0 && <p className="p-8 text-center font-mono text-sm text-[#52525B]" data-testid="carts-empty">No open carts.</p>}
            {carts.map((c) => (
              <div key={c.email} className="px-6 py-5 border-b border-zinc-900 flex items-center justify-between gap-4 hover:bg-[#0C0C0C] transition-colors" data-testid={`cart-row-${c.email}`}>
                <div className="min-w-0">
                  <p className="flex items-center gap-2 font-mono text-sm truncate"><Mail size={14} color="#D4AF37" /> {c.email}</p>
                  <p className="text-sm text-[#71717A] mt-1 truncate">{(c.items || []).map((i) => `${i.name} ×${i.qty}`).join(" · ")}</p>
                </div>
                <div className="flex items-center gap-3 shrink-0">
                  <span className="font-serif text-2xl">${c.total}</span>
                  <button onClick={() => nudge(c.email, false)} data-testid={`nudge-${c.email}`}
                    className="flex items-center gap-2 bg-[#D4AF37] text-black px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.15em] hover:bg-[#C5A028] transition-colors">
                    <Mail size={13} /> {c.nudged ? "Nudge Again" : "Send Reminder"}
                  </button>
                  {c.nudged && (
                    <button onClick={() => nudge(c.email, true)} data-testid={`force-nudge-${c.email}`}
                      className="border border-zinc-700 px-3 py-2.5 font-mono text-[10px] uppercase tracking-[0.15em] text-[#A1A1AA] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
                      Force
                    </button>
                  )}
                  <button onClick={() => deleteCart(c.email)} data-testid={`cart-delete-${c.email}`} aria-label={`Delete cart for ${c.email}`}
                    className="border border-zinc-700 p-2.5 text-[#52525B] hover:border-red-500 hover:text-red-400 transition-colors">
                    <Trash2 size={14} />
                  </button>
                </div>
              </div>
            ))}
          </div>
  );
}
